import { create } from 'zustand'

import type { ConfirmRequest } from '../components'

export const useConfirmStore = create<{
  request: ConfirmRequest | null
  set(r: ConfirmRequest | null): void
}>((set) => ({
  request: null,
  set: (request) => set({ request }),
}))
